import React, { useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";

// project-imports
import Spinner from "../spinner-component/SpinnerOne";
import { GoogleAnalyticsEnum, triggerFunction } from "../../utils/google-analytics";
import { formatDateWithSuffixV2, getThumbnailFromYouTube } from "../../utils";

const GalleryDrawer = ({
    show,
    onClose,
    title,
    data,
    classes,
    bgWhite,
    onViewUserRatings,
    onAddReview,
    isLoading,
    onDownloadClick,
    onVideoToggle
}) => {
    // constant variable
    const desc = (data && data?.desc ? data?.desc : "").replace(/\n/g, '<br/>');
    let published = data && data?.publishedAt ? data?.publishedAt : "";
    let publishedDate = formatDateWithSuffixV2(published) || "";
    const likeCount = data && data?.likesCount ? data?.likesCount : "";
    const commentCount = data && data?.ytCommentCount ? data?.ytCommentCount : "";
    const viewCount = data && data?.viewdCount ? data?.viewdCount : "";
    const videoThumbnail = data?.featuredImage;

    // Constant function
    const handleVideoError = () => {
        console.log("Video failed to load.");
    };

    return (
        <>
            {isLoading && <Spinner />}
            <div className={`generic-drawer mt-0 ${(show) ? "active" : ""}`}>
                <div className="inner">
                    <div className="header-top">
                        <div className="logo">
                            <Link to={process.env.PUBLIC_URL + "/"}>
                                <img src="/images/logo/lsa-long-logo.png" alt="Main Logo" />
                            </Link>
                        </div>
                        <h6 className="logo mb-0 text-start">{title}</h6>
                        <div className="close-menu">
                            <button className="close-button" onClick={onClose}>
                                <i className="ri-close-line"></i>
                            </button>
                        </div>
                    </div>
                    <div className="text-center mt-1">
                        <div className="container ebook-drawer" id="maindiv">
                            <div className="row">
                                <div className="col-12">

                                    <div className={`edu-card card-type-4 radius-small eduvibe-course-style-four ${classes ? classes : ''} ${bgWhite === 'enable' ? 'bg-white' : ''}`}>
                                        <div className="row">

                                            <div className="col-12 p--10">
                                                <div className="inner">
                                                    <div className="thumbnail">
                                                        <div className="video-area">
                                                            <div className="thumbnail video-popup-wrapper">
                                                                {/* working as aspected code start  */}
                                                                <video
                                                                    className="radius-small w-100"
                                                                    controls
                                                                    poster={
                                                                        videoThumbnail ||
                                                                        `${process.env.PUBLIC_URL}/images/course/video-bg/default-image.jpg`
                                                                    }
                                                                    onError={handleVideoError}
                                                                // height={"199px"}
                                                                >
                                                                    <source src={[data?.videoUrl]} type="video/mp4" />
                                                                    Your browser does not support the video tag.
                                                                </video>

                                                                <button
                                                                    onClick={() => { onVideoToggle(data?.videoUrl); triggerFunction(window.location.href + GoogleAnalyticsEnum.LSA_SALESFORCE_TUTORIALS_VIDEO_PLAYED_BUTTON_CLICKED, data?.snippet?.title); }}
                                                                    className="video-play-btn position-to-top video-popup-activation"
                                                                >
                                                                    <span className="drawer-play-icon"></span>
                                                                </button>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 pt-4">
                                    <div className="row px-4">
                                        <div className="col-12 text-start">
                                            <h6 className="title mb--0">
                                                {data?.cleanTitle}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 pt-4">
                                    <div className="row px-4">
                                        <div className="col-12 col-sm-6 text-start d-flex gap-3 align-items-center">
                                            <p>{viewCount} views </p>
                                            <p> {publishedDate}</p>
                                        </div>
                                        <div className="col-12 col-sm-6 d-flex gap-3 justify-content-start justify-content-sm-end align-items-center">
                                            <p>{likeCount} likes </p>
                                            <p>{commentCount > 0 ? `${commentCount} comments` : ""}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="row px-4">
                                        <div className="col-12 text-start">
                                            <p className="m-0" dangerouslySetInnerHTML={{ __html: desc }}></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GalleryDrawer;
